import WeeklyWorkTime from './view';

const WeeklyWorkTimePage = {
    name: 'WeeklyWorkTime',
    list: WeeklyWorkTime
};

export default WeeklyWorkTimePage;